/**
 * Single source of truth for API URLs.
 * Production: same-origin /api/... (Cloudflare Pages function).
 * Development: optional REACT_APP_BACKEND_URL prefix.
 */

const BACKEND_ORIGIN = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export function getBackendOrigin() {
  return BACKEND_ORIGIN;
}

/**
 * @param {string} path - e.g. "/business-anatomy/MSFT" or "business-anatomy/MSFT"
 * @returns {string} Absolute or root-relative API URL
 */
export function apiUrl(path) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const apiPath = normalized.startsWith("/api/") ? normalized : `/api${normalized}`;

  if (apiPath.includes("undefined")) {
    throw new Error(`Invalid API path contains "undefined": ${apiPath}`);
  }

  if (BACKEND_ORIGIN) {
    return `${BACKEND_ORIGIN}${apiPath}`;
  }

  if (process.env.NODE_ENV === "development" && !process.env.REACT_APP_BACKEND_URL) {
    // Same-origin /api still works when CRA proxy is configured; warn once in dev console.
    if (typeof window !== "undefined" && !window.__ROOH_API_URL_WARNED) {
      window.__ROOH_API_URL_WARNED = true;
      console.info("[apiUrl] Using same-origin", apiPath, "(set REACT_APP_BACKEND_URL for direct backend)");
    }
  }

  return apiPath;
}

/** @returns {boolean} */
export function isValidApiUrl(url) {
  if (!url || typeof url !== "string") return false;
  if (url.includes("undefined")) return false;
  if (url.startsWith("undefined")) return false;
  return url.includes("/api/");
}

export { BACKEND_ORIGIN as BACKEND_URL };
